import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import MailIcon from '@material-ui/icons/Mail';
import ResolvedIcon from '@material-ui/icons/CheckCircle';
import InProgressIcon from '@material-ui/icons/Timelapse';
import CancelledIcon from '@material-ui/icons/DeleteForever';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import MoveToInboxIcon from '@material-ui/icons/MoveToInbox';
import { RequestStatus } from '../userRequests/types';

export const UserRequestStatusIcon = ({
  status,
}: {
  status: RequestStatus;
}) => {
  const palette = useTheme().palette;
  const color = {
    New: palette.warning.main,
    'In progress': palette.warning.main,
    Received: palette.info.main,
    Resolved: palette.success.main,
    Reopened: palette.primary.main,
    Canceled: palette.error.main,
  }[status];

  const style = { color, fontSize: 20 };

  switch (status) {
    case 'New':
      return <MailIcon style={style} />;
    case 'In progress':
      return <InProgressIcon style={style} />;
    case 'Received':
      return <MoveToInboxIcon style={style} />;
    case 'Resolved':
      return <ResolvedIcon style={style} />;
    case 'Reopened':
      return <MeetingRoomIcon style={style} />;
    case 'Canceled':
    default:
      return <CancelledIcon style={style} />;
  }
};
